import { render } from "./NeuralAssist.vue?vue&type=template&id=faf67390"
import script from "./NeuralAssist.vue?vue&type=script&lang=js"
export * from "./NeuralAssist.vue?vue&type=script&lang=js"

import "./NeuralAssist.vue?vue&type=style&index=0&id=faf67390&lang=css"
script.render = render

export default script